<template>
    <svg xmlns="http://www.w3.org/2000/svg" id="Livello_1" data-name="Livello 1" viewBox="0 0 24 24" fill="currentColor"><path d="M1.91 5.01H22.1v1.55H1.91zM1.91 11.22h13.97v1.55H1.91zM1.91 17.43h7.76v1.55H1.91z"/></svg>
</template>

